const validate = values => {
    const errors = {fecha: '', ruta: ''};
    if (!values.fecha) {
        errors.fecha = 'Seleccione una fecha';
    }

    if (!values.ruta) {
        errors.ruta = 'Seleccione una ruta';
    }
    return errors;
};

export default validate;


// WEBPACK FOOTER //
// ./src/components/pages/comprobantes/validate.ts